module.exports = __webpack_public_path__ + "static/media/fire_burning.82fa2e95.wav";


//////////////////
// WEBPACK FOOTER
// ./src/sound/fire_burning.wav
// module id = 30
// module chunks = 0